import { Checkbox, Col, Divider, Form, Row } from "antd";
import React, { useEffect, useState } from "react";
import PrimaryButton from "../../biblio/Buttons/PrimaryButton";
import { showNotitfication } from "../utils/utils";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../apis/store";
import {
  toAddSurvey,
  toAddSurveyResponse,
  toGetSurvey,
} from "../../apis/actions/survey.actions";
interface Props {
  questions: any;
  surveyId: any;
  setActiveItem: any;
}
const NewSurvey = ({ questions, surveyId, setActiveItem }: Props) => {
  const dispatch = useDispatch<AppDispatch>();
  const [form] = Form.useForm();
  const [selectedChoices, setSelectedChoices] = useState<any[]>([]);
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);
  const { targeted, type } = useSelector((state: RootState) => state.survey);
  const handleCheckboxChange = (
    questionId: number,
    choiceId: number,
    type: string
  ) => {
    const l__selectedChoice = [...selectedChoices];
    const index = l__selectedChoice.findIndex(
      (el) => el.question_id === questionId
    );

    if (index !== -1) {
      if (l__selectedChoice[index].choice_ids.includes(choiceId)) {
        l__selectedChoice[index].choice_ids =
          type === "one"
            ? []
            : l__selectedChoice[index].choice_ids.filter(
                (id: any) => id !== choiceId
              );
      } else {
        l__selectedChoice[index].choice_ids =
          type === "one"
            ? [choiceId]
            : [...l__selectedChoice[index].choice_ids, choiceId];
      }
    }
    setSelectedChoices(l__selectedChoice);
  };

  const isChecked = (questionId: number, choiceId: number) => {
    if (selectedChoices.length === 0) return false;
    return selectedChoices
      ?.filter((el) => el.question_id === questionId)[0]
      ?.choice_ids.includes(choiceId);
  };
  useEffect(() => {
    const list: any[] = [];
    questions.forEach((el: any) => {
      list.push({ question_id: el.id, choice_ids: [] });
    });
    setSelectedChoices(list);
  }, [questions]);

  useEffect(() => {
    const allAnswered = selectedChoices?.every(
      (choice) => choice?.choice_ids?.length > 0
    );
    setIsButtonDisabled(!allAnswered);
  }, [selectedChoices]);
  const onFinish = async () => {
    try {
      await form.validateFields();

      const surveyFormData = {
        survey_id: surveyId,
        questions: selectedChoices,
      };

      dispatch(
        type === "external"
          ? toAddSurvey(surveyFormData)
          : toAddSurveyResponse(surveyFormData)
      ).then((result: any) => {
        setIsButtonDisabled(true);
        const survey = result?.payload?.result;
        if (survey?.code === 200) {
          showNotitfication(survey?.message, "success");
          setActiveItem("result");
          dispatch(toGetSurvey([targeted]));
          form.resetFields();
        } else {
          setIsButtonDisabled(false);

          showNotitfication(survey?.message, "error");
        }
      });
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <Form form={form} layout="vertical">
      <Row gutter={8} dir="rtl">
        <Col xxl={11} xl={11} lg={11} md={11} sm={24} xs={24}>
          {questions
            ?.slice(0, Math.round(questions.length / 2))
            .map((question: any) => (
              <div className="takaful--question-content">
                <Form.Item name="question_id" valuePropName="question_id">
                  <span className="takaful--content-services-request-span takaful--color-span">
                    {question?.question}
                  </span>
                </Form.Item>
                {question.choices?.map((choice: any) => (
                  <Form.Item name="choice_ids" valuePropName="choice_ids">
                    <Checkbox
                      onChange={() =>
                        handleCheckboxChange(
                          question.id,
                          choice?.id,
                          question.choice_type
                        )
                      }
                      checked={isChecked(question.id, choice?.id)}
                    >
                      <span className="takaful--content-services-request-span takaful--color-span">
                        {choice?.choice}
                      </span>
                    </Checkbox>
                  </Form.Item>
                ))}
              </div>
            ))}
        </Col>
        <Col xxl={1} xl={1} lg={1} md={1} sm={0} xs={0}>
          {questions?.length > 1 && (
            <Divider
              type="vertical"
              className="takaful--survey-verticale-divider"
            />
          )}
        </Col>
        <Col xxl={11} xl={11} lg={11} md={11} sm={24} xs={24}>
          {questions
            ?.slice(Math.ceil(questions.length / 2), questions.length)
            .map((question: any) => (
              <div className="takaful--question-content">
                <span className="takaful--content-services-request-span takaful--color-span">
                  {question?.question}
                </span>
                {question.choices?.map((choice: any, index: number) => (
                  <Form.Item name="choice_ids" valuePropName="choice_ids">
                    <Checkbox
                      onChange={() =>
                        handleCheckboxChange(
                          question.id,
                          choice?.id,
                          question.choice_type
                        )
                      }
                      checked={isChecked(question.id, choice?.id)}
                    >
                      <span className="takaful--content-services-request-span takaful--color-span">
                        {choice?.choice}
                      </span>
                    </Checkbox>
                  </Form.Item>
                ))}
              </div>
            ))}
        </Col>
      </Row>
      <Row dir="rtl" justify={"end"} style={{ marginTop: "3rem" }}>
        <Col
          style={{ display: "flex", justifyContent: "flex-end" }}
          xxl={12}
          xl={12}
          lg={12}
          md={12}
          sm={24}
          xs={24}
        >
          <PrimaryButton
            className={`${
              isButtonDisabled ? "takaful--inactive" : "takaful--btn-color"
            }`}
            title="إرسال "
            disabled={isButtonDisabled}
            onClick={onFinish}
          />
        </Col>
      </Row>
    </Form>
  );
};

export default NewSurvey;
